// Function to calculate the greatest common divisor (GCD) of two numbers
const gcd = (a, b) => {
  // Using Euclid's algorithm
  while (b !== 0) {
    const temp = b;
    b = a % b;
    a = temp;
  }
  return a;
};

// Function to calculate the least common multiple (LCM) of two numbers
const lcm = (a, b) => {
  return a * b / gcd(a, b);
};

// Function to calculate the least common multiple (LCM) of an array of numbers
export const lcmArray = numbers => {
  // Using the fact that LCM(a, b, c) = LCM(LCM(a, b), c)
  let result = numbers[0];
  for (let i = 1; i < numbers.length; i++) {
    result = lcm(result, numbers[i]);
  }
  return result;
};
//# sourceMappingURL=mathUtils.js.map